import React from "react";
import classes from "./AddPayoutMethod.module.css";
import Colors from "../../../../../stories/assets/Colors";
import Fonts from "../../../../../stories/assets/Fonts";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import { Input } from "../../../../../stories/Input/Input";
import { Button } from "../../../../../stories/Button/Button";
import { LinkButtonWithIcon } from "../../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { Row, Col } from "react-bootstrap";

const AddPayoutMethod = ({
  show,
  setShow,
  cardNumber,
  setCardNumber,
  date,
  setDate,
  cvv,
  setCvv,
}) => {
  return (
    <>
      <style>
        {`
            .modal-body{
                padding:32px;
                padding-top:0px;
            }
            @media screen and (max-width:768px){
                .modal .modal-dialog {
                    max-width: 80%;
                    margin: 0px auto;
                }
            }
            @media screen and (max-width:480px){
                .modal .modal-dialog {
                    max-width: 95%;
                    margin: 0px auto;
                }
            }
        `}
      </style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        borderRadius={"20px"}
        width={"509px"}
        headerStyles={{ marginBottom: "0px", paddingBottom: "24px" }}
        header={
          <h4
            style={{
              ...Fonts.h4,
              fontSize: "26px",
              color: Colors.neutralShadesOfNero,
            }}
          >
            Add payout method
          </h4>
        }
        footer={
          <div className={classes.footerBtns}>
            <LinkButtonWithIcon
              text={"Cancel"}
              textColor={Colors.neutralShadesOfNero}
            />
            <Button
              label={"Add"}
              primary={true}
              size={"Medium"}
              disabled={true}
              customStyle={{
                width: "max-content",
                height: "48px",
                marginLeft: "48px",
              }}
            />
          </div>
        }
      >
        <div className={classes.modalContent}>
          <Row>
            <Col xs={12} className={classes.mb24}>
              <Input
                label="Card number"
                type="number"
                placeholder="0000 0000 0000 0000"
                state={cardNumber}
                setter={setCardNumber}
              />
            </Col>
            <Col xs={6}>
              <Input
                label="Expiration date"
                type="date"
                placeholder="DD/MM/YY"
                state={date}
                setter={setDate}
                inputStyle={{ padding: "12px 16px" }}
              />
            </Col>
            <Col xs={6}>
              <Input
                label="CVV"
                type="password"
                placeholder="Security code"
                state={cvv}
                setter={setCvv}
              />
            </Col>
          </Row>
        </div>
      </ModalSkeleton>
    </>
  );
};

export default AddPayoutMethod;
